import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FlexLoadingSpinner } from 'components/helpers/LoadingSpinner';
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  CategoryScale,
  BarElement,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  ChartDataLabels
);

const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    datalabels: {
      display: true,
      color: 'white',
      font: { size: 16, weight: 'bold' },
    },
  },
};

const PieChart = ({ data: d, title, cls, emptyText, isLoading }) => {
  const { t } = useTranslation();
  const resolvedEmptyText = emptyText !== undefined ? emptyText : t('dashboard.noData');
  if (isLoading) {
    return (
      <div className={`${cls || ''} o-dashboard-card__wrap`}>
        {title ? <strong>{title}</strong> : <strong><span style={{ visibility: 'hidden' }}>Title</span></strong>}
        <div className='o-dashboard-card u-padding-bottom--small cs-bg--light'>
          <div className='column'>
            <div className='o-chart--line u-flex u-flex-center'>
              <FlexLoadingSpinner />
            </div>
          </div>
        </div>
      </div>
    )
  }


  const colors = ['#5ac9ac', '#ffce15', '#e7831e', '#ea054d', '#43ff64'];

  const data = {
    labels: Object.values(d).map(item => item.legend),
    datasets: [
      {
        data: Object.values(d).map(item => item.value),
        backgroundColor: colors,
      },
    ],
  };

  return (
    <div className={`${cls || ''} o-dashboard-card__wrap`}>
      {title ? <strong>{title}</strong> : <strong><span style={{ visibility: 'hidden' }}>Title</span></strong>}
      <div className='o-dashboard-card u-padding-bottom--small cs-bg--light'>
        <div className='column'>
          <div className='o-chart--line u-flex u-flex-center'>
            {Object.keys(d).length === 0 ? <div className='o-chart--line__no-data u-txt--center'>{resolvedEmptyText}</div> : (
              <Pie data={data} options={options} />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

PieChart.defaultProps = {}

PieChart.propTypes = {
  cls: PropTypes.string,
  title: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  emptyText: PropTypes.string,
  isLoading: PropTypes.bool,
}

export default PieChart;
